import React, { useState, useEffect } from 'react';
import AdminSubPage from '../components/AdminSubPage';
import { api } from '../lib/api';
import { Button } from '../components/ui/button';
import { Copy, Download, Smartphone } from 'lucide-react';
import { toast } from 'sonner';

const MobileApiGuidePage = () => {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/admin/mobile-api-guide').then(r => {
      setContent(typeof r.data === 'string' ? r.data : r.data.content || JSON.stringify(r.data));
      setLoading(false);
    }).catch(() => { setContent('Failed to load guide.'); setLoading(false); });
  }, []);

  const handleCopy = () => {
    navigator.clipboard.writeText(content);
    toast.success('Guide copied to clipboard — share with your mobile dev team');
  };

  const handleDownload = () => {
    const blob = new Blob([content], { type: 'text/markdown' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'MOBILE_API_GUIDE.md';
    a.click();
    URL.revokeObjectURL(url);
    toast.success('Guide downloaded as MOBILE_API_GUIDE.md');
  };

  return (
    <AdminSubPage title="Mobile App API Guide" breadcrumb={['Admin', 'System', 'Mobile API Guide']} backPath="/dashboard/admin/system">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Smartphone className="w-5 h-5 text-[#C5A059]" />
          <p className="text-sm text-gray-500">Integration guide for the mobile development team. Covers auth, accounts, transfers, loans, shares, and groups.</p>
        </div>
        <div className="flex gap-2">
          <Button variant="outline" size="sm" onClick={handleCopy} className="text-xs gap-1.5" data-testid="copy-guide"><Copy className="w-3.5 h-3.5" />Copy</Button>
          <Button size="sm" onClick={handleDownload} className="bg-[#1f1f1f] text-white text-xs gap-1.5" data-testid="download-guide"><Download className="w-3.5 h-3.5" />Download .md</Button>
        </div>
      </div>
      {loading ? (
        <div className="text-center py-8 text-gray-400">Loading...</div>
      ) : (
        <div className="bg-white border border-gray-200 p-6 max-h-[75vh] overflow-y-auto">
          <pre className="whitespace-pre-wrap text-sm text-gray-800 font-mono leading-relaxed" data-testid="guide-content">{content}</pre>
        </div>
      )}
    </AdminSubPage>
  );
};

export default MobileApiGuidePage;
